import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { textInCapitalCase } from '../../../../../../helpers/TextHelper';
import { useBenefitsListStyles } from './styles';

const ListItem = ({ ...props }) => {
  const { title, description } = props;
  const classes = useBenefitsListStyles();
  return (
    <React.Fragment>
      <Typography className={classes.subtitle}>
        {textInCapitalCase(title)}
      </Typography>
      <Typography>{description} </Typography>
    </React.Fragment>
  );
};

ListItem.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

export default ListItem;
